
import { FirebaseContext } from '../../firebase/context';
import { useContext, useEffect, useState } from 'react';
import './welcome.css'

const Welcome = () => {
    const [name, setName] = useState('')
    const firebase = useContext(FirebaseContext)


    const getName = () => {
        const db = firebase.firestore()
        firebase.auth().onAuthStateChanged(function (user) {
            if (user) {
                const docRef = db.collection('users').doc(firebase.auth().currentUser.uid)
                docRef.get().then(res => {
                    const data = res.data();
                    if (data && data.first) {
                        setName(data.first)
                    }
                })
            }
        })
    }

    useEffect(() => {
        getName()
    }, [])

    return (
        <div>
            <h1>Welcome to the exercise{name ? `, ${name}!` : '!'}</h1>
            <div id="step1-message" style={{ textAlign: 'left', padding: 32 }}>
                <p>In this exercise, we'll test you on some fundamental concepts of front-end development</p>
                <h3>Let's start w/ an orientation to the exercise:</h3>
                <ul>
                    <li>All steps of the exercise will look like the example you're on now.</li>
                    <li>On the right side is a text editor where you will provide your answers either in JavaScript or plain text.</li>
                    <li>Instructions for each step of the exercise will be located in the left panel, where this text is located.</li>
                    <li>For answers requiring JavaScript, you can use the "Run" button to run and test code. <strong>Click the Run button to see the code on the right change the color of the welcome message.</strong></li>
                    <li>Your answers will auto save as you type. <strong>Add a comment to the code on the right to watch it save.</strong></li>
                    <li>If you need to restore the default answer provided, click the "Reset" button above the editor. <strong>Click the Reset button and notice the comment you added will be removed.</strong></li>
                    <li>Mark each step complete with the checkbox above the editor.</li>
                    <li>When you've finished the exercise, click "Submit Exercise" in the sidenav to the left.</li>
                    
                </ul>
                <br></br>
                <h3>Let's get started!</h3>
                <ul>
                    <li>Each step of the exercise is displayed on the left hand nav.</li>
                    <li><strong>Mark this step complete before moving to the next step.</strong></li>
                    <li>Now that you've completed this example, you can click to the next step to begin!</li>
                </ul>
            </div>

        </div>
    );
}

export default Welcome;
